/**
 * restore-toasts.ts — komunikaty po przywróceniu usuniętego konta (`POST /users/:id/restore`).
 *
 * Wspólne dla listy użytkowników (`Users.tsx`) i zakładki „Bezpieczeństwo" (`UserSecurityTab`),
 * żeby oba miejsca mówiły to samo: toast sukcesu, a gdy konto wróciło BEZ powiązania z pracownikiem
 * (ten pracownik ma już inne żywe konto) — dodatkowo toast informacyjny.
 */

import type { TFunction } from 'i18next';

import type { ToastContextValue } from '@/contexts/ToastContext';
import type { UserRestoreResponse } from '@/lib/use-tenant-people';

export function showUserRestoredToasts(
  toast: ToastContextValue,
  t: TFunction,
  data: UserRestoreResponse | undefined,
): void {
  toast.show({ variant: 'success', title: t('tenant.users.toast.restored') });
  if (data?.employeeUnlinked) {
    toast.show({ variant: 'info', title: t('tenant.users.toast.restoredWithoutEmployee') });
  }
}
